<template>
  <intersection-wrapper :threshold="[0.4, 0.6]" class="article-card">
    <template #default="intersection">
      <div
        class="article-card__inner"
        :class="{ 'article-card__inner_visible': intersection.intersected }"
      >
        <div class="article-card__published">
          {{ publishedAt }}
        </div>
        <div class="article-card___details">
          <h2 class="article-card__title">
            <a :href="url" class="article-card__link">
              {{ title }}
            </a>
          </h2>
          <div class="article-card__excerpt" v-html="excerptText" />
          <a :href="url" class="article-card__cta article-card__link"> Read more </a>
        </div>
        <div
          class="article-card__image-container"
          :class="{
            'article-card__image-container_landscape': imageAspectRatio >= 1,
          }"
        >
          <image-loader :alt="title" :src="imageSrc" class="article-card__image" />
        </div>
      </div>
    </template>
  </intersection-wrapper>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    handle: {
      type: String,
      default: '',
    },
    imageAspectRatio: {
      type: Number,
      default: 0,
    },
    imageSrc: {
      type: String,
      default: '',
    },
    publishedAt: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    excerpt: {
      type: String,
      default: '',
    },
  },

  computed: {
    excerptText() {
      return this.excerpt.split('<!--excerpt-->')[0].trim()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/frontend/variables';
@import '~styles/frontend/mixins';

.article-card {
  & + .article-card {
    border-top: 1px solid;
  }

  &__inner {
    display: grid;
    grid-template-columns: 3fr 9fr 11fr;
    padding: 40px $inset;

    @media (max-width: 700px) {
      grid-template-columns: var(--blog-feature-column-template_mob);
      min-height: var(--blog-feature-card-min-height);
    }
  }

  &__title,
  &__excerpt,
  &__published,
  &__cta,
  &__image-container {
    opacity: 0;
    transition: all 0.6s ease;
  }

  &__excerpt,
  &__published,
  &__cta {
    transition-delay: 0.3s;
  }

  &__inner_visible & {
    &__title,
    &__excerpt,
    &__published,
    &__cta,
    &__image-container {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__title {
    @include uppercase;

    margin-bottom: 20px;
    transform: translateY(15px);
  }

  &__excerpt {
    max-width: 200px;
  }

  &__cta {
    display: inline-block;
    margin-top: 15px;
  }

  &__image-container {
    display: grid;
    grid-template-columns: 3fr 4fr 4fr;
    transform: translateY(15px);
    transition-delay: 0.4s;

    &_landscape {
      grid-template-columns: 2fr 5fr 4fr;
    }

    @media (max-width: 700px) {
      grid-column: 1 / -1;
      grid-row: 2;
      grid-template-columns: 3fr 3fr 3fr;
      margin-top: 40px;

      &_landscape {
        grid-template-columns: 2fr 5fr 2fr;
      }
    }
  }

  &__image {
    grid-column: 2;
  }

  &__link {
    @media (min-width: 700px) {
      @include animate-underline-v2;
    }
  }
}
</style>
